// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__1kX79","app_auth":"App_app_auth__CyHMH"};